import { Helmet, HelmetProvider } from "react-helmet-async";
import TopHeader from "../../components/TopHeader";
import EtablissementHeader from "../../components/EtablissementHeader";
import Proprietaire from "./proprietaire";
import OpeningHours from "../../components/OpeningHours";
import EmplacementEtablissement from "../../components/emplacement";

import BlocEtablissement from "./blocsEtablissement";
import Footer from "../../components/Footer";
import { useEffect, useState } from "react";
import { get } from "../../services/services";
import { fetchEtablissementsByTag } from "../../store/slices/etablissementSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CategoriesGoogle from '../../utils/type.json'
const SingleNonInscrit = () => {
  const [businessData, setBusinessData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  // console.log(location?.state);
  const dispatch = useDispatch();
  // const placeId = params?.id;
  const { selectedEtablissementId, status } = useSelector(
    (state) => state.etablissements
  );
  const placeId = selectedEtablissementId ?? location?.state?.placeId;
  const { etablissementsByTag, tagStatus } = useSelector(
    (state) => state.etablissements
  );

  useEffect(() => {
    if (placeId) {
      dispatch(fetchEtablissementsByTag("type=newest"));
    }
  }, [dispatch, placeId]);

  const fetchPublicBusinessData = async () => {
    if (!placeId) return; // Don't fetch if no placeId

    setLoading(true);
    try {
      const response = await get(`google-etablissements/${placeId}`);
      // console.log('response.data',response.data)
      setBusinessData(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPublicBusinessData();
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Page détails établissement Google my business</title>
          <meta
            name="description"
            content="Services, horaires d'ouverture, emplacement, l'équipe, les avis ..."
          />
        </Helmet>
      </HelmetProvider>

      <TopHeader  btn={true}/>

      <div className="container">
        <div className="single-etablissement">
          <EtablissementHeader
            status={status}
            etablissement={{
              nom:
                status === "loading" ? (
                  <Skeleton width={200} />
                ) : (
                  businessData?.nom
                ),
              activite: {
                name:
                  status === "loading" ? (
                    <Skeleton width={150} />
                  ) : (
                    CategoriesGoogle[businessData?.types[0]]
                  ),
              },
              adresse_postale: businessData?.adresse
                ? businessData?.adresse
                : "",
              code_postal: "",
              ville: "",
              lat: businessData?.lat,
              lng: businessData?.lng,
              lieu_intervention: [],
              average_rating: loading ? (
                <Skeleton width={50} />
              ) : (
                businessData?.reviews?.length
              ),
              // reviews_count: loading ? (
              //   <Skeleton width={50} />
              // ) : (
              //   businessData?.reviews?.length 
              //   ? businessData.reviews.reduce((acc, review) => acc + review.rating, 0) / businessData.reviews.length
              //   : 0 // or null, or whatever default you prefer
              // ),
            }}
            inscrit={false}
          />

          <div className="row mt-24">
            <div className="col-md-8">
              <Proprietaire
                proprietaire={
                  loading ? <Skeleton width={180} /> : businessData?.nom
                }
                placeId={placeId}
              />

              <EmplacementEtablissement
                title={
                  loading ? (
                    <Skeleton width={300} />
                  ) : (
                    `Où se situe ${businessData?.nom} ? `
                  )
                }
                adr={
                  loading ? (
                    <Skeleton width={250} />
                  ) : (
                    businessData?.adresse
                  )
                }
                LatLng={{
                  id: 1,
                  lat: loading
                    ? businessData?.lat
                    : businessData?.lat,
                  lng: loading
                    ? businessData?.lng
                    : businessData?.lng,
                }}
              />

              {/* <BlocTitleText
                title={"À propos"}
                text={
                  loading
                    ? <Skeleton count={5} height={15} />
                    : selectedEtablissement?.description
                }
              /> */}
            </div>

            <div className="col-md-4">
              {businessData?.opening_hours?.weekday_text && (
                <OpeningHours
                  horaires={
                    loading
                      ? Array(7)
                          .fill("")
                          .map((_, i) => (
                            <Skeleton
                              key={i}
                              height={20}
                              style={{ marginBottom: "6px" }}
                            />
                          ))
                      : businessData?.opening_hours?.weekday_text || []
                  }
                  status={status}
                  inscrit={false}
                />
              )}
            </div>
          </div>

          {tagStatus === "loading" ? (
            <div className="mt-4">
              <h4>
                <Skeleton width={220} />
              </h4>
              <div className="row">
                {Array(4)
                  .fill("")
                  .map((_, index) => (
                    <div className="col-md-3 mb-4" key={index}>
                      <Skeleton height={150} />
                      <Skeleton
                        height={20}
                        width={`80%`}
                        style={{ marginTop: "10px" }}
                      />
                    </div>
                  ))}
              </div>
            </div>
          ) : (
            etablissementsByTag && (
              <BlocEtablissement
                title={"Nouveaux sur Twyny"}
                loading={tagStatus === "loading"}
                etablissements={etablissementsByTag || []}
                showCount={4}
              />
            )
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default SingleNonInscrit;
